// tslint:disable
/**
 * Labor Protection API (Russian)
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { EducationProtocol } from '../models';
import { EducationProtocolExport } from '../models';
import { EducationProtocolExportList } from '../models';
import { EducationProtocolExportPreChecks } from '../models';
import { EducationProtocolList } from '../models';
/**
 * EducationProtocolApi - axios parameter creator
 * @export
 */
export const EducationProtocolApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EducationProtocolExport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEducationProtocol(body: EducationProtocolExport, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling exportEducationProtocol.');
            }
            const localVarPath = `/labor-protection/ru/education-protocols/exports`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEducationProtocol(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEducationProtocol.');
            }
            const localVarPath = `/labor-protection/ru/education-protocol/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportEducationProtocol(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getExportEducationProtocol.');
            }
            const localVarPath = `/labor-protection/ru/education-protocols/export/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {string} [courseId] 
         * @param {string} [number] 
         * @param {Date} [exportedAtMin] 
         * @param {Date} [exportedAtMax] 
         * @param {boolean} [isExported] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEducationProtocols(ids?: Array<string>, companyId?: string, courseId?: string, number?: string, exportedAtMin?: Date, exportedAtMax?: Date, isExported?: boolean, offset?: number, limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/labor-protection/ru/education-protocols`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (number !== undefined) {
                localVarQueryParameter['number'] = number;
            }

            if (exportedAtMin !== undefined) {
                localVarQueryParameter['exportedAtMin'] = (exportedAtMin as any).toISOString();
            }

            if (exportedAtMax !== undefined) {
                localVarQueryParameter['exportedAtMax'] = (exportedAtMax as any).toISOString();
            }

            if (isExported !== undefined) {
                localVarQueryParameter['isExported'] = isExported;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {Array<string>} [protocolIds] 
         * @param {Array<'waiting' | 'started' | 'success' | 'fail'>} [statuses] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExportsEducationProtocol(ids?: Array<string>, companyId?: string, protocolIds?: Array<string>, statuses?: Array<'waiting' | 'started' | 'success' | 'fail'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, sort?: 'startedAt' | 'finishedAt' | 'createdAt', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/labor-protection/ru/education-protocols/exports`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (protocolIds) {
                localVarQueryParameter['protocolIds'] = protocolIds.join(COLLECTION_FORMATS.csv);
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses.join(COLLECTION_FORMATS.csv);
            }

            if (startedAtMin !== undefined) {
                localVarQueryParameter['startedAtMin'] = (startedAtMin as any).toISOString();
            }

            if (startedAtMax !== undefined) {
                localVarQueryParameter['startedAtMax'] = (startedAtMax as any).toISOString();
            }

            if (finishedAtMin !== undefined) {
                localVarQueryParameter['finishedAtMin'] = (finishedAtMin as any).toISOString();
            }

            if (finishedAtMax !== undefined) {
                localVarQueryParameter['finishedAtMax'] = (finishedAtMax as any).toISOString();
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EducationProtocolExport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preChecksExportEducationProtocol(body: EducationProtocolExport, options: any = {}): RequestArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling preChecksExportEducationProtocol.');
            }
            const localVarPath = `/labor-protection/ru/education-protocols/exports/prechecks`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EducationProtocolApi - functional programming interface
 * @export
 */
export const EducationProtocolApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EducationProtocolExport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEducationProtocol(body: EducationProtocolExport, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationProtocolExport> {
            const localVarAxiosArgs = EducationProtocolApiAxiosParamCreator(configuration).exportEducationProtocol(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEducationProtocol(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationProtocol> {
            const localVarAxiosArgs = EducationProtocolApiAxiosParamCreator(configuration).getEducationProtocol(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportEducationProtocol(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationProtocolExport> {
            const localVarAxiosArgs = EducationProtocolApiAxiosParamCreator(configuration).getExportEducationProtocol(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {string} [courseId] 
         * @param {string} [number] 
         * @param {Date} [exportedAtMin] 
         * @param {Date} [exportedAtMax] 
         * @param {boolean} [isExported] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEducationProtocols(ids?: Array<string>, companyId?: string, courseId?: string, number?: string, exportedAtMin?: Date, exportedAtMax?: Date, isExported?: boolean, offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationProtocolList> {
            const localVarAxiosArgs = EducationProtocolApiAxiosParamCreator(configuration).listEducationProtocols(ids, companyId, courseId, number, exportedAtMin, exportedAtMax, isExported, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {Array<string>} [protocolIds] 
         * @param {Array<'waiting' | 'started' | 'success' | 'fail'>} [statuses] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExportsEducationProtocol(ids?: Array<string>, companyId?: string, protocolIds?: Array<string>, statuses?: Array<'waiting' | 'started' | 'success' | 'fail'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, sort?: 'startedAt' | 'finishedAt' | 'createdAt', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationProtocolExportList> {
            const localVarAxiosArgs = EducationProtocolApiAxiosParamCreator(configuration).listExportsEducationProtocol(ids, companyId, protocolIds, statuses, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, sort, order, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {EducationProtocolExport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preChecksExportEducationProtocol(body: EducationProtocolExport, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationProtocolExportPreChecks> {
            const localVarAxiosArgs = EducationProtocolApiAxiosParamCreator(configuration).preChecksExportEducationProtocol(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EducationProtocolApi - factory interface
 * @export
 */
export const EducationProtocolApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {EducationProtocolExport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportEducationProtocol(body: EducationProtocolExport, options?: any) {
            return EducationProtocolApiFp(configuration).exportEducationProtocol(body, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEducationProtocol(id: string, options?: any) {
            return EducationProtocolApiFp(configuration).getEducationProtocol(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportEducationProtocol(id: string, options?: any) {
            return EducationProtocolApiFp(configuration).getExportEducationProtocol(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {string} [courseId] 
         * @param {string} [number] 
         * @param {Date} [exportedAtMin] 
         * @param {Date} [exportedAtMax] 
         * @param {boolean} [isExported] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEducationProtocols(ids?: Array<string>, companyId?: string, courseId?: string, number?: string, exportedAtMin?: Date, exportedAtMax?: Date, isExported?: boolean, offset?: number, limit?: number, options?: any) {
            return EducationProtocolApiFp(configuration).listEducationProtocols(ids, companyId, courseId, number, exportedAtMin, exportedAtMax, isExported, offset, limit, options)(axios, basePath);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {string} [companyId] 
         * @param {Array<string>} [protocolIds] 
         * @param {Array<'waiting' | 'started' | 'success' | 'fail'>} [statuses] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {'startedAt' | 'finishedAt' | 'createdAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExportsEducationProtocol(ids?: Array<string>, companyId?: string, protocolIds?: Array<string>, statuses?: Array<'waiting' | 'started' | 'success' | 'fail'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, sort?: 'startedAt' | 'finishedAt' | 'createdAt', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
            return EducationProtocolApiFp(configuration).listExportsEducationProtocol(ids, companyId, protocolIds, statuses, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, sort, order, offset, limit, options)(axios, basePath);
        },
        /**
         * 
         * @param {EducationProtocolExport} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preChecksExportEducationProtocol(body: EducationProtocolExport, options?: any) {
            return EducationProtocolApiFp(configuration).preChecksExportEducationProtocol(body, options)(axios, basePath);
        },
    };
};

/**
 * EducationProtocolApi - object-oriented interface
 * @export
 * @class EducationProtocolApi
 * @extends {BaseAPI}
 */
export class EducationProtocolApi extends BaseAPI {
    /**
     * 
     * @param {EducationProtocolExport} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationProtocolApi
     */
    public exportEducationProtocol(body: EducationProtocolExport, options?: any) {
        return EducationProtocolApiFp(this.configuration).exportEducationProtocol(body, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationProtocolApi
     */
    public getEducationProtocol(id: string, options?: any) {
        return EducationProtocolApiFp(this.configuration).getEducationProtocol(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationProtocolApi
     */
    public getExportEducationProtocol(id: string, options?: any) {
        return EducationProtocolApiFp(this.configuration).getExportEducationProtocol(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {string} [companyId] 
     * @param {string} [courseId] 
     * @param {string} [number] 
     * @param {Date} [exportedAtMin] 
     * @param {Date} [exportedAtMax] 
     * @param {boolean} [isExported] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationProtocolApi
     */
    public listEducationProtocols(ids?: Array<string>, companyId?: string, courseId?: string, number?: string, exportedAtMin?: Date, exportedAtMax?: Date, isExported?: boolean, offset?: number, limit?: number, options?: any) {
        return EducationProtocolApiFp(this.configuration).listEducationProtocols(ids, companyId, courseId, number, exportedAtMin, exportedAtMax, isExported, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {Array<string>} [ids] 
     * @param {string} [companyId] 
     * @param {Array<string>} [protocolIds] 
     * @param {Array<'waiting' | 'started' | 'success' | 'fail'>} [statuses] 
     * @param {Date} [startedAtMin] 
     * @param {Date} [startedAtMax] 
     * @param {Date} [finishedAtMin] 
     * @param {Date} [finishedAtMax] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {'startedAt' | 'finishedAt' | 'createdAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationProtocolApi
     */
    public listExportsEducationProtocol(ids?: Array<string>, companyId?: string, protocolIds?: Array<string>, statuses?: Array<'waiting' | 'started' | 'success' | 'fail'>, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, sort?: 'startedAt' | 'finishedAt' | 'createdAt', order?: 'ASC' | 'DESC', offset?: number, limit?: number, options?: any) {
        return EducationProtocolApiFp(this.configuration).listExportsEducationProtocol(ids, companyId, protocolIds, statuses, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, sort, order, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {EducationProtocolExport} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EducationProtocolApi
     */
    public preChecksExportEducationProtocol(body: EducationProtocolExport, options?: any) {
        return EducationProtocolApiFp(this.configuration).preChecksExportEducationProtocol(body, options)(this.axios, this.basePath);
    }

}
